<div class="w-10/12 sm:w-9/12 mx-auto pygmaliosBlog">
  <iframe
    [src]="cleanUrl()"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
  >
  </iframe>
</div>
